var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, FlexBox, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './styles.module.scss';
export function LauncherIconPickerField(_a) {
    var { className, options } = _a, wrappedFieldProps = __rest(_a, ["className", "options"]);
    return (_jsx("div", Object.assign({ className: classnames(className, styles.optionsRoot) }, { children: options.map((option) => (_jsx(Option, { option: option, onSelect: wrappedFieldProps.input.onChange, isSelected: wrappedFieldProps.input.value === option.id }, option.id))) })));
}
function Option({ option, isSelected, onSelect, }) {
    return (_jsxs(FlexBox, Object.assign({ gap: "100", alignItems: "center", flexDirection: "column", justifyContent: "center", onClick: option.lockedFeature ? undefined : () => onSelect(option.id), className: classnames(styles.launcherIconOption, {
            [styles.launcherIconOptionSelected]: isSelected,
            [styles.launcherIconOptionDisabled]: option.lockedFeature,
        }) }, { children: [_jsx(FlexBox, Object.assign({ justifyContent: "center", alignItems: "center", className: styles.launcherIconOptionPreview }, { children: _jsx("div", { children: option.icon }) })), _jsx("div", { children: _jsx(Text.Paragraph, Object.assign({ variant: "2", color: "inherit" }, { children: option.title })) }), option.lockedFeature && (_jsx(Badge, Object.assign({ size: "small", variant: "secondary", className: styles.featureLockedBadge }, { children: "Upgrade to access" })))] })));
}
